module.exports = __webpack_public_path__ + "img/four-lanes.c0261375.jpg";